import { getAPI } from "../../../../api/apis"
import { REACT_APP_JOB } from "../../../../utils/common"

export async function getAppliedJobs(candidateId: String){
    const Details = getAPI( REACT_APP_JOB + `/position-details?candidateId=${candidateId}`)
    return Details
}

